import React from 'react';
import '../App.css'; // Adjust the path if your CSS is elsewhere
import HeroSection from '../components/HeroSection';
import { Helmet } from 'react-helmet-async';

const About = () => {
  return (
    <>
    <Helmet>
        <title>About Us – Blackswift Inventories | Southern Africa Market Experts</title>
        <meta name="description" content="Founded by Emmanuel Chinsasa, Blackswift Inventories offers deep local insight and integrated execution for brands entering Southern African markets." />
      </Helmet>
    
      {/* Hero Section */}
      <HeroSection 
  title="Our Story"
  subtitle="Founded by Emmanuel Chinsasa after years of operating at the intersection of international manufacturing and Southern African markets."
  buttonText="Meet the Team"          // optional
  buttonLink="#founder"                // optional anchor
  backgroundImage="/about-bg.jpg"      // your image path
  showIllustration={false}
/>

      {/* Founder Section */}
      <section className="section">
        <div className="container">
          <div className="founder-container">
            <div className="founder-image-wrapper">
              <img 
                src="/CEO.jpeg" 
                alt="Emmanuel Chinsasa, Founder & CEO" 
                className="founder-image"
              />
              <h3 className="founder-name">Emmanuel Chinsasa</h3>
              <p className="founder-title">Founder & CEO</p>
            </div>
            <div className="founder-text">
              <h2>A Different Approach</h2>
              <p>
                From the beginning, we took a different approach: <strong>deep local insight, 
                integrated route-to-market execution, and hands-on brand stewardship</strong>. 
                We don't just help brands enter the market — we ensure they perform reliably, 
                protect their reputation, and grow sustainably.
              </p>
              <p>
                Our founder made supply chain execution a strategic priority. In a region 
                shaped by volatility and operational complexity, resilience, transparency, 
                and ethical sourcing are non-negotiable. We align supply chain, commercial 
                strategy, and brand management into a single, disciplined system.
              </p>
              <blockquote className="quote">
                "We operate as a trusted partner, taking ownership of execution and 
                long-term brand outcomes. Growth is deliberate, partnerships are 
                collaborative, and success is measured by lasting impact."
              </blockquote>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Values */}
      <section className="section section-dark">
        <div className="container">
          <h2 className="text-center">Our Mission & Values</h2>
          
          <div className="mission-card">
            <h3>Mission</h3>
            <p className="mission-text">
              To provide international manufacturers with a trusted route to market in 
              Southern Africa through deep market intelligence, integrated supply chain 
              execution, and hands-on brand stewardship that drives sustainable growth.
            </p>
          </div>

          <div className="values-grid">
            <div className="value-card">
              <h4>Trust & Accountability</h4>
              <p>Earning trust through transparency, governance, and accountable execution.</p>
            </div>
            <div className="value-card">
              <h4>Market-Led Insight</h4>
              <p>Decisions shaped by deep local intelligence and real-time market understanding.</p>
            </div>
            <div className="value-card">
              <h4>Integrated Execution</h4>
              <p>Connecting strategy, supply chain, and brand management into one operating model.</p>
            </div>
            <div className="value-card">
              <h4>Strategic Supply Chain</h4>
              <p>Designing resilient, ethical supply chains aligned with long-term objectives.</p>
            </div>
            <div className="value-card">
              <h4>Brand Stewardship</h4>
              <p>Hands-on responsibility for brand integrity throughout the market lifecycle.</p>
            </div>
            <div className="value-card">
              <h4>Sustainable Growth</h4>
              <p>Pursuing growth that is deliberate, resilient, and built to endure.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;